import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AppConfigService } from '../../core/services/app-config/app-config.service';
import { AuthGuardData, createAuthGuard } from 'keycloak-angular';
import { AuthService } from '../services/auth.service';
import { AuthStatus } from '../models/auth-status';
import { inject } from '@angular/core';

const isAccessAllowed = async (
	route: ActivatedRouteSnapshot,
	_: RouterStateSnapshot,
	_authData: AuthGuardData
): Promise<boolean | UrlTree> => {

	const router = inject(Router);
	const authSvc = inject(AuthService);
	const configSvc = inject(AppConfigService);

	const authStatus: AuthStatus = authSvc.getAuthenticationStatus();

	if (authStatus === AuthStatus.LOGGED_IN) {

		const requiredRoles: string[] = route.data['roles'] || [];

		const hasRequiredRoles = authSvc.checkRealmRolesIncludeAnyOfRequiredRoles(requiredRoles);

		if (hasRequiredRoles) { return true; } else {
			return router.parseUrl(configSvc.settings.accessDeniedUrlPath);
		}

	} else if (authStatus === AuthStatus.LOGGED_OUT) {

		authSvc.login();
		return false;

	} else if (authStatus === AuthStatus.ERROR) {

		return router.parseUrl(configSvc.settings.loginErrorUrlPath);

	}

	return router.parseUrl(configSvc.settings.accessDeniedUrlPath);

};

const demoModeCanActivateFn: CanActivateFn = () => true;

export const canActivateAuthRole: CanActivateFn = (route, state) => {

	const configSvc = inject(AppConfigService);

	if (configSvc.settings.demoMode) {
		return demoModeCanActivateFn(route, state);
	}
	
	return createAuthGuard<CanActivateFn>(isAccessAllowed)(route, state);

};